export const flattenTreeData = (state, action) => {
  const data = Array.isArray(action.payload) ? action.payload : [action.payload];
  state.folderTree.value = data;
  state.folderTree.loading = false;

  const tree = [];
  const flattenFolderTree = (array) => {
    array.forEach((item) => {
      tree.push(item);
      if (Array.isArray(item.children) && item.children.length > 0) {
        flattenFolderTree(item.children);
      }
    });
  };

  flattenFolderTree(data);
  state.flattenFolderTree = tree;
};

export const handlePending = (state, key) => {
  state[key].loading = true;
};

export const handleRejected = (state, key) => {
  state[key].loading = false;
};

export const handleFulfilled = (state, key, action) => {
  state[key].value = action.payload;
  state[key].loading = false;
};
